export default {
  columnHeader: {
    simulatedDuration: 'Simulierte Dauer',
  },
  acceptSimulatedDuration: 'Simulierte Dauer übernehmen: {0}',
};
